// import { reports, sectionMeta } from "../data/Knowledge";
// import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

// /* AssochamReport.jsx
//    Listing page for Assocham's research reports.
//    Image banner + title hero; clickable banner cards open the
//    detail overview + download page (handled by the parent router). */
// export default function AssochamReport({ onOpen }) {
//   return (
//     <KnowledgeSection
//       section={sectionMeta.reports}
//       items={reports}
//       onOpen={onOpen}
//     />
//   );
// }



import { useNavigate } from "react-router-dom";
import { reports, sectionMeta } from "../data/Knowledge";
import KnowledgeSection from "../KnowledgeCenter/KnowledgeSection";

export default function AssochamReport() {
  const navigate = useNavigate();

  return (
    <KnowledgeSection
      section={sectionMeta.reports}
      items={reports}
      onOpen={(item) => navigate(`/knowledge/reports/${item.id}`)}
    />
  );
}